import { NavLink } from 'react-router';
import { Badge } from '../../../design-system/badge/badge';
import { Inline } from '../../../design-system/inline/inline';
import { Tooltip } from '../../../design-system/tooltip/tooltip';
import { cn } from '../../../utils/cn';
import { getNavItemContent } from '../utils/get-nav-item-content';

type NavItemProps = {
  variant: Parameters<typeof getNavItemContent>[0];
  disabledConfig: { isDisabled: true; label: string } | { isDisabled: false };
};

// TODO: This component uses different typography styles https://linear.app/seapoint/issue/TENG-1708/align-app-typography-with-figma
export const NavItem = ({ variant, disabledConfig }: NavItemProps) => {
  const { icon: Icon, label, linkTo, isBeta } = getNavItemContent(variant);

  if (disabledConfig.isDisabled) {
    return (
      <Tooltip
        trigger={
          <Inline space={4} className="py-2.5 pl-2.5">
            <Icon size={16} className="text-seapoint-gray-text group-hover:text-black" />

            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-normal leading-[22px] -tracking-[0.02em] text-seapoint-gray-text">
              {label}
            </p>
          </Inline>
        }
        content={
          <p className="text-sm font-normal leading-[22px] -tracking-[0.02em] text-seapoint-gray-text">
            {disabledConfig.label}
          </p>
        }
        triggerClassName="cursor-not-allowed"
      />
    );
  }

  return (
    // Using NavLink to get the active state
    // https://reactrouter.com/6.30.0/components/nav-link
    <NavLink to={linkTo} className="w-full">
      {({ isActive }) => (
        <div className="relative w-full">
          <Inline
            space={4}
            className={cn('group relative w-full items-center py-2.5 pl-2.5 pr-2.5', {
              'rounded-[10px] bg-white': isActive,
              '*:text-black': isActive,
            })}
          >
            <Icon size={16} className="text-seapoint-gray-text group-hover:text-black" />

            <p
              className={cn(
                'flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-normal leading-[22px] -tracking-[0.02em]',
                isActive ? 'text-black' : 'text-seapoint-gray-text group-hover:text-black',
              )}
            >
              {label}
            </p>

            {isBeta && (
              <Badge variant="warning" shape="pill">
                Beta
              </Badge>
            )}
          </Inline>
        </div>
      )}
    </NavLink>
  );
};
